import { capitalCase } from 'change-case'

export const normalizeErrorSimple = (label: string, error: string) => {
  if (!error) return null

  // Make the errors more human friendly
  if (error === 'Expected string, received null') {
    return `${label} is Required`
  } else if (error.startsWith('String must')) {
    return error.replace('String must', `${capitalCase(label)} must`)
  } else if (error.startsWith('Number must')) {
    return error.replace('Number must', `${label} must`)
  } else if (error === 'Invalid cuid') {
    return `${label} is invalid`
  }

  return error
}
